export const navLinks = [
  { label: 'שירותים', href: '#services' },
  { label: 'למה אנחנו', href: '#why-us' },
  { label: 'איך זה עובד', href: '#how-it-works' },
  { label: 'מחירים', href: '#pricing' },
  { label: 'צור קשר', href: '#contact' },
];

export const whyUsCards = [
  {
    icon: 'MapPin',
    title: 'באים עד הבית',
    description: 'לא צריך לבזבז זמן ולנסוע. אנחנו מגיעים אליך — הביתה, למשרד, לכל מקום בנוח ובזמן שמתאים לך.',
    highlighted: true,
  },
  {
    icon: 'DollarSign',
    title: 'מחיר הוגן בהתחייבות',
    description: 'שקיפות מלאה — מחיר ידוע מראש, ללא הפתעות. לא כמו מעבדות שגובות יותר ממה שצריך.',
    highlighted: false,
  },
  {
    icon: 'Shield',
    title: 'אחריות על כל תיקון',
    description: 'כל תיקון מגיע עם אחריות מלאה. אם יש בעיה אחרי התיקון — אנחנו מחזירים ומתקנים בחינם.',
    highlighted: false,
  },
  {
    icon: 'Clock',
    title: 'תיקון מהיר ויעיל',
    description: 'רוב התיקונים מסתיימים תוך שעה אחת. לא צריך להישאר ימים בלי הטלפון.',
    highlighted: false,
  },
  {
    icon: 'ThumbsUp',
    title: 'טכנאים מוסמכים',
    description: 'הטכנאים שלנו עברו הכשרה מקצועית, ויש להם ניסיון עשיר בתיקון כל דגמי הסמארטפון.',
    highlighted: false,
  },
  {
    icon: 'Star',
    title: 'חווית שירות מעולה',
    description: 'הלקוח הוא במרכז. שירות אנושי, יחס אישי, ותמיד זמינים לשאלות לפני ואחרי התיקון.',
    highlighted: false,
  },
];

export const includedFeatures = [
  'אבחון מלא עולה 150 ש"ח',
  'הגעה עד הבית — ללא תוספת',
  'אחריות על 90 אחוז מהתיקונים',
  'חלקים איכותיים בלבד',
  'מחיר ידוע לפני התיקון',
  'טכנאי מוסמך ומנוסה',
];

export const repairTypes = [
  { title: 'החלפת מסך', description: 'לכל הדגמים — iPhone, Samsung, Xiaomi ועוד' },
  { title: 'החלפת סוללה', description: 'סוללה מקורית ואיכותית — חיי סוללה כמו חדש' },
  { title: 'תיקון שקע טעינה', description: 'מחברים של תקינים — USB-C, Lightning' },
  { title: 'תיקון גב שבור', description: 'זכוכית אחורית לכל סדרות האייפון והסמסונג' },
  { title: 'תיקון רמקול ומיקרופון', description: 'קול חזק וברור כמו שצריך' },
  { title: 'תיקון מצלמה', description: 'החלפה ותיקון מצלמה קדמית ואחורית' },
];

export const techFeatures = [
  {
    icon: 'Search',
    title: 'אבחון מדויק',
    description: 'משתמשים בציוד אבחון מקצועי לזיהוי מדויק של הבעיה — לא ניחושים, רק עובדות.',
  },
  {
    icon: 'Cpu',
    title: 'ציוד מקצועי',
    description: 'כלי עבודה מקצועיים ברמה גבוהה — אותם כלים שמשתמשים בהם מעבדות מורשות.',
  },
  {
    icon: 'CheckSquare',
    title: 'חלקים איכותיים',
    description: 'עובדים רק עם חלקי חילוף איכותיים שעוברים בדיקת איכות לפני התקנה.',
  },
  {
    icon: 'Settings',
    title: 'ניסיון מעשי',
    description: 'שנים של ניסיון בתיקון כל סוגי הסמארטפון — כל תיקון מבוצע בקפידה ובמיומנות.',
  },
];

export const brands = [
  'Apple iPhone',
  'Samsung Galaxy',
  'Xiaomi / Redmi',
  'Huawei',
  'OnePlus',
  'Google Pixel',
];

export const howItWorksSteps = [
  {
    number: '01',
    icon: 'Phone',
    title: 'צור קשר',
    description: 'התקשר אלינו, שלח WhatsApp, או מלא את הטופס שקיים בתחתית האתר. נקשיב לבעיה ונספק הצעת מחיר מיידית.',
  },
  {
    number: '02',
    icon: 'MapPin',
    title: 'קובעים מועד',
    description: 'קובעים זמן שנוח לך — אצלך בבית, בעבודה, או בכל מקום שתבחר. אנחנו מגיעים אליך.',
  },
  {
    number: '03',
    icon: 'Wrench',
    title: 'תיקון מקצועי',
    description: 'הטכנאי מגיע עם כל הציוד הנדרש ומתקן את הטלפון שלך במקום, במהירות!',
  },
  {
    number: '04',
    icon: 'CheckCircle',
    title: 'מחזירים לך שלם',
    description: 'הטלפון חוזר אליך תקין עם אחריות על התיקון. אתה ממשיך ביומך כאילו כלום לא קרה.',
  },
];

export const testimonials = [
  {
    name: 'יוסי כהן',
    text: 'שירות מדהים! הטכנאי הגיע תוך שעה והחליף לי את המסך בדיוק כמו חדש. ממליץ בחום!',
    rating: 5,
    location: 'תל אביב',
  },
  {
    name: 'שרה לוי',
    text: 'המחיר היה הוגן והשירות מקצועי. הטלפון שלי עובד מצוין אחרי ההחלפת סוללה.',
    rating: 5,
    location: 'רמת גן',
  },
  {
    name: 'דוד אברהם',
    text: 'הזמנתי תיקון שקע טעינה. הטכנאי הגיע במועד, עבד מהר ונקי. שירות 5 כוכבים!',
    rating: 5,
    location: 'פתח תקווה',
  },
  {
    name: 'רונית מזרחי',
    text: 'גב האייפון שלי נשבר ותוך יום קיבלתי שירות מעולה עד הבית. ממליצה לכולם!',
    rating: 5,
    location: 'הרצליה',
  },
];

export const contactInfo = {
  phone: '053-2222342',
  whatsapp: 'https://wa.me/9720532222342',
  email: 'info@geniemobile.co.il',
  serviceArea: 'אזור פתח תקווה והסביבה, אזור השרון וראש העין',
  hours: 'ראשון-שישי: 08:00-22:00',
  ownerName: 'עדיאל עמרם',
  social: {
    instagram: 'https://www.instagram.com/adiel_amram3',
    facebook: 'https://www.facebook.com/share/1RVBxb5gVi/',
    tiktok: 'https://www.tiktok.com/@adielamram',
  },
};

export const pricingBanner = {
  title: 'המחיר הכי משתלם בשוק — בהתחייבות!',
  subtitle: 'מחיר שקוף, ללא הפתעות, עם אחריות מלאה',
};
